/*
 * MAIN SCRIPT
 * DON'T WRITE FUNCTION HERE, ONLY CALL THEM
 *
 * **/
document.addEventListener('DOMContentLoaded', (event) => {
    initFormFieldsToggle();
    initRecaptcha();
    initFormsValidation();
    initModalResponse();
    initIubendaProof();
    initLoadMore();
    initFilter();
    initVideo();
    initPagesSliderWidget();
    initToggler();
    initAos();
    initHeadingsSliderWidget();
    const simpleTextWidgetArray = document.querySelectorAll(".text-simple-widget");
    simpleTextWidgetArray.forEach(simpleTextWidget => {
        if (simpleTextWidget) {
            const h2Element = simpleTextWidget.querySelector("h2");
            const aElement = simpleTextWidget.querySelector("a.cta");
            if (h2Element && aElement && simpleTextWidget.children.length === 2) {
                simpleTextWidget.classList.add("inline-elements");
            }
        }
    });
});
